var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{attrs:{"name":_vm.name,"scale":_vm.scale,"spin":_vm.spin,"pulse":_vm.pulse,"inverse":_vm.inverse,"flip":_vm.flip,"label":_vm.label,"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }